// Legacy URL-declared custom tabs are same-domain, so a manifest fetch works and lets CustomTab pick
// the zone before rendering. Delete once URL tabs migrate to appIds.

const embeddableOrigins = {};

export const getAppInfo = async (url) => {
  let origin;
  try {
    origin = new URL(url).origin;

    if (embeddableOrigins[origin] !== undefined) {
      return embeddableOrigins[origin];
    }

    const res = await fetch(`${origin}/mm-app-manifest.json`);
    const data = await res.json();

    if (!data.version) {
      throw new Error('Invalid manifest');
    }

    embeddableOrigins[origin] = data;
    return data;
  } catch (error) {
    // Not embeddable / unreachable / invalid manifest.
  }

  if (origin) {
    embeddableOrigins[origin] = false;
  }
  return false;
};

export const testIsEmbeddable = async (url) => {
  return !!(await getAppInfo(url));
};
